import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { defaultBody, emailPattern, mobilePattern, noWhitespaceInRequiredValidator, splitPattern } from '../../shared/constants';
import { map, Observable, startWith } from 'rxjs';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { environment } from '../../../environments/environment';
import { EmailFormatterService } from '../../email-formatter.service';

@Component({
	selector: 'app-welcome-mail',
	templateUrl: './welcome-mail.component.html',
	styleUrl: './welcome-mail.component.css'
})
export class WelcomeMailComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/vessel",
			name: "Vessels"
		}
	];
	vesselId: any = null;
	defaultSubject = "3Cube Medicare - Duty of Care Services";

	requiredValidator = Validators.required;
	moduleForm: FormGroup = this.formBuilder.group({
		cc_emails: [environment.WELCOME_MAIL_CC],
		bcc_emails: [null],
		subject: [this.defaultSubject, [this.requiredValidator]],
		mail_content: [defaultBody, [this.requiredValidator]],
		/* language: ["English", [Validators.required]] */
	});
	/* languages: any = [
		{ name: "English", val: "English" },
		{ name: "Chinese", val: "Chinese" }
	]; */
	vesselDetails: any = null;
	showMailLoader = false;
	pageLoading = false;
	accessLoader = false;
	user_type: any = "";
	files: File[] = [];
	mailIdPlaceholder = "Please add email address and press space bar.";
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		if (!control.value.match(emailPattern)) {
			return {
				'emailerr': true
			};
		}
		return null;
	}
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline', 'strike'],
				['blockquote', 'code-block'],
				[{ 'header': 1 }, { 'header': 2 }],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'script': 'sub' }, { 'script': 'super' }],
				[{ 'indent': '-1' }, { 'indent': '+1' }],
				[{ 'direction': 'rtl' }],
				[{ 'size': ['small', false, 'large', 'huge'] }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }],
				['clean'],
				['link']
			],
		}
	}
	splitPattern = splitPattern;

	constructor(private emailFormatter: EmailFormatterService, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe((data: any) => {
			this.accessLoader = false;
			try {
				this.user_type = data.res[0].user_type;
			} catch (error) { }
		}, (error: any) => {
			this.accessLoader = false;
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			let vesselId = routeParams["vesselId"];
			try {
				vesselId = decodeURIComponent(vesselId);
			} catch (e) { }
			this.vesselId = vesselId;
			this.breadcrumbList.push({ path: "/app/welcome-mail/" + this.vesselId, name: "Welcome Mail" });
			this.getDetails();
			this.getDefaultFile();
		});
	}

	getDetails() {
		this.apiService.getVesselDetails({ "id": this.vesselId }).subscribe({
			next: (data: any) => {
				this.vesselDetails = data.data;
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getDefaultFile() {
		this.apiService.getDefaultFilesForWelcomeMail().subscribe({
			next: (resList: any) => {
				const fileNames = ["AWARENESS POSTER-1.pdf", "Awareness_Poster-2.pdf", "SMART_MEDICAL_REQUEST.pdf"];
				for (let i = 0; i < resList.length; i++) {
					let excelData: any = resList[i].body;
					let blob = new Blob([excelData], { type: "application/ms-excel" });
					this.files.push(
						new File([blob], fileNames[i], {
							type: blob.type,
							lastModified: new Date().getTime()
						})
					);
				}
			}, error: (error) => {
				if (error.status == 401) { return }
				this.toastr.error("Unable to get default files", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	public uploadFile(files: NgxFileDropEntry[]) {
		for (let i = 0; i < files.length; i++) {
			if (files[i].fileEntry.isFile) {
				const fileEntry = files[i].fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.files.push(file);
				});
				this.moduleForm.markAsDirty();
			} else {
				this.toastr.error("Invalid File Format.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}
	}

	removeFile(index: number) {
		this.files.splice(index, 1);
	}

	get f1() { return this.moduleForm.controls; }

	showError(field: string) {
		if (this.f1[field].invalid && (this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	sendMail() {
		console.log(this.f1.mail_content.value)
		if (!this.vesselDetails?.email) {
			this.toastr.error("No email id in vessel", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required parameters", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		} let cc_emails = this.f1.cc_emails.value ? this.f1.cc_emails.value : [];
		let bcc_emails = this.f1.bcc_emails.value ? this.f1.bcc_emails.value : [];
		let formData = new FormData();
		const emailReadyHtml = this.emailFormatter.prepareQuillHtmlForEmail(this.f1.mail_content.value);
		formData.append("id", atob(this.vesselId));
		formData.append("cc_emails", JSON.stringify(cc_emails));
		formData.append("bcc_emails", JSON.stringify(bcc_emails));
		formData.append("subject", this.f1.subject.value);
		formData.append("mail_content", emailReadyHtml);
		formData.append("count", this.files.length.toString());
		for (let i = 0; i < this.files.length; i++) {
			formData.append("attachments_" + i, this.files[i]);
		}
		/* formData.append("language",this.f1.language.value); */
		this.showMailLoader = true;
		this.apiService.sendWelcomeMail(formData).subscribe({
			next: data => {
				this.showMailLoader = false;
				this.toastr.success("Mail sent successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.router.navigate(['/app/vessel']);
			}, error: (error) => {
				this.showMailLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}
}
